
import { useContext, useRef } from 'react';

import styles from './PD_ParticipantComponent.module.css'

import { ProjectDetailsContext } from "../../../contexts/projectDetailsContext";
import { GlobalContext } from "../../../contexts/globalContext";

import InitialsCircleComponent from '../../commons/InitialsCircleComponent'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

const PD_ParticipantComponent = ({ participant }) => {

    const deleteRef = useRef()

    const { socketRef, selectedProject, setAlertMessage, appWidth, appHeight, } = useContext(GlobalContext);

    const { setDeleteClicked } = useContext(ProjectDetailsContext);

    const oxDivider = window.innerWidth / appWidth;
    const oyDivider = window.innerHeight / appHeight;

    function deleteParticipant() {
        if (selectedProject.participants.length > 1) {
            socketRef.current.emit("DELETE_PARTICIPANT_FROM_PROJECT",
                { projectId: selectedProject._id, participantId: participant._id }, (result) => {
                    if (result.error) {
                        setAlertMessage({ type: "ERROR", message: result.message });
                    } else {
                        setDeleteClicked(false);
                    }
                    
                }
            );
        }
    }

    const handleDelete = (e) => {
        e.stopPropagation();
        if (!deleteRef.current) return;

        const rect = deleteRef.current.getBoundingClientRect();

        let x = rect.x
        let y = rect.y

        if(x / oxDivider - 1024 + 739 > appWidth){
            x = (appWidth - 760 ) * oxDivider
        }

        if(y / oyDivider + 255 > appHeight){
            y = (appHeight - 275) * oyDivider
        }

        setDeleteClicked({
            shown: true,
            funct: deleteParticipant,
            name: "Participant",
            x: x + 90,
            y: y,
            onClose: () => setDeleteClicked(),
        });
    };

    return (
        <>
            <div key={participant._id} className={styles.element}>
                <div className={styles.info}>
                    <InitialsCircleComponent name={participant.name} />
                    <div className={styles.participantDetails}>
                        {participant.name}
                        <div className={styles.participantDescription} style={{ marginTop: 15 }}>
                            Role:
                            <div className={styles.participantRole}>{participant.role}</div>
                        </div>
                        {participant.department && <div className={styles.participantDescription}>
                            Department:
                            <div className={styles.participantRole} style={{ color: "#FFFFFF" }}>{participant.department.name}</div>
                        </div>}
                    </div>
                </div>

                {selectedProject.participants.length > 1 &&
                    <FontAwesomeIcon
                        ref={deleteRef}
                        className={styles.iconButton}
                        style={{ right: 50, top: 50, fontSize: 32 }}
                        icon={byPrefixAndName.fal["trash"]}
                        onClick={(e) => { handleDelete(e) }}
                    />
                }
            </div>
        </>



    );

}

export default PD_ParticipantComponent;